import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PageLoadingComponent } from './page-loading/page-loading.component';
import { PagePropertiesComponent } from './page-properties/page-properties.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PageUnderConstructionComponent } from './page-under-construction/page-under-construction.component';
import { FilterCollectionComponent } from './filter-collection/filter-collection.component';
import { ViewFieldComponent } from './partials/view-field/view-field.component';
import { ListFieldComponent } from './partials/list-field/list-field.component';
import { LoadingComponent } from './partials/loading/loading.component';
import { StandAloneFooterComponent } from './partials/stand-alone-footer/stand-alone-footer.component';
import { DataTableComponent } from './data-table/data-table.component';
import { OverlayComponent } from './overlay/overlay.component';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    PageLoadingComponent,
    PagePropertiesComponent,
    PageTitleComponent,
    PageNotFoundComponent,
    PaginationComponent,
    PageUnderConstructionComponent,
    FilterCollectionComponent,
    ViewFieldComponent,
    ListFieldComponent,
    LoadingComponent,
    StandAloneFooterComponent,
    DataTableComponent,
    OverlayComponent,
  ],
  imports: [CommonModule, RouterModule, FormsModule],
  exports: [
    FooterComponent,
    HeaderComponent,
    PageLoadingComponent,
    PagePropertiesComponent,
    PageTitleComponent,
    PageNotFoundComponent,
    PaginationComponent,
    PageUnderConstructionComponent,
    FilterCollectionComponent,
    ViewFieldComponent,
    ListFieldComponent,
    LoadingComponent,
    StandAloneFooterComponent,
    OverlayComponent
  ],
})

/**
 * dir-w | backOffice
 * Shared components used by most of all main page components
 *
 * Last update : June 8, 2024 | @rizkiprasetya
 */
export class SharedModule {}
